<div class="btn-group">
  <button
    type="button"
    class="btn btn-actions btn-actions--position btn-just-icon p-0 btn-sm mx-1 hvr-shrink descripcion-emergente-govco bottom"
    data-bs-toggle="dropdown"
    data-bs-auto-close="outside"
    aria-expanded="false"
    id="dropdownAlertasButton"
    (mouseenter)="mostrarTooltip('alertas')"
    (mouseleave)="ocultarTooltip()"
    aria-label="Ver alertas">
    <span class="tiptext" *ngIf="tooltipVisible === 'alertas'">{{ 'visualizar_alertas.alertas' | translate }}</span>
    <div class="notification-icon d-flex flex-row align-items-center">
      <span class="govco-svg govco-bell icos__nav__user"></span>
      <span
        class="position-absolute top-0 start-100 translate-middle badge badge__Notifications rounded-pill bg-danger">
        {{ countAlertas }}
        <span class="visually-hidden">{{
          'visualizar_alertas.alertas_sin_leer' | translate
        }}</span>
      </span>
    </div>
  </button>

  <div
    id="dropdownAlertas"
    class="dropdown-menu dropdown-menu-end"
    data-bs-auto-close="outside"
    aria-labelledby="dropdownAlertasButton">
    <div class="d-flex flex-column p-3 dropdown__alertas">
      <div class="fixed-top mt-3">
        <form
          [formGroup]="filtrosAlertas"
          (change)="pagina = 1; filtrarAlertas()">
          <div class="d-flex flex-row justify-content-around ps-3 ps-md-0">
            <div class="">
              <div class="form-check form-check-inline">
                <label class="font-weight-bold">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    formControlName="noLeido" />
                  {{ 'visualizar_alertas.no_leidas' | translate }}
                </label>
              </div>
            </div>
            <div class="">
              <div class="form-check form-check-inline">
                <label class="font-weight-bold">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    formControlName="archivado" />
                  {{ 'visualizar_alertas.archivadas' | translate }}
                </label>
              </div>
            </div>
            <div class="">
              <div class="form-check form-check-inline">
                <label class="font-weight-bold">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    formControlName="prioritario" />
                  {{ 'visualizar_alertas.prioritarias' | translate }}
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="overflow-y-auto height__container--alert">
        <div class="rounded border my-2 p-2" *ngFor="let alerta of alertas">
          <div class="row align-items-center">
            <div class="col-12 col-md-2">
              {{ alerta.Fecha_Creacion | date: 'dd/MM/yyyy' }}
            </div>
            <div class="col-12 col-md-8">
              <div
                class="d-flex flex-row align-items-center"
                *ngIf="alerta.Titulo === 'Descarga BD'">
                {{ alerta.Detalle }}
                <button
                  type="button"
                  (click)="descargarDocumento(alerta?.DB_Id)"
                  class="link-tipografia-govco hvr-shrink"
                  [attr.aria-label]="'visualizar_alertas.descargar' | translate">
                  {{ 'visualizar_alertas.descargar' | translate }}
                </button>
              </div>
              <div
                class="d-flex flex-row align-items-center"
                *ngIf="alerta.Expediente">
                {{ alerta.Expediente.Tipo_Proceso?.Entidad?.Entidad }}
                <button
                  type="button"
                  (click)="detalleExpediente(alerta.Expediente, alerta.Usuario_Id)"
                  class="link-tipografia-govco hvr-shrink"
                  [attr.aria-label]="alerta.Expediente.Radicado">
                  {{ alerta.Expediente.Radicado }}
                </button>
              </div>
              <div *ngIf="!alerta.Expediente && alerta.Titulo != 'Descarga BD'">
                {{ alerta.Detalle }}
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div
                class="d-flex flex-row align-items-center justify-content-between">
                <button
                  type="button"
                  class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink"
                  (click)="cambiarEstadoLeido(alerta.Id)"
                  arial-label="Cambiar estado leído/no leído">
                  <i
                    class="fa fa-lg"
                    [ngClass]="{
                      'fa-eye': alerta.Leido,
                      'fa-eye-slash': !alerta.Leido,
                    }"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink"
                  (click)="cambiarEstadoArchivado(alerta.Id)"
                  aria-label="Cambiar estado archivado/no archivado">
                  <i
                    class="fa fa-lg"
                    [ngClass]="{
                      'fa-file-archive-o': !alerta.Archivado,
                      'fa-archive': alerta.Archivado,
                    }"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-actions btn-just-icon p-0 btn-sm mx-1 hvr-shrink"
                  (click)="cambiarEstadoPrioritario(alerta.Id)"
                  aria-label="Cambiar estado prioritario/no prioritario">
                  <i
                    class="fa fa-lg"
                    [ngClass]="{
                      'fa-flag': alerta.Prioritario,
                      'fa-flag-o': !alerta.Prioritario,
                    }"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row justify-content-center my-3"
          *ngIf="this.pagina <= totalPaginas">
          <button
            type="button"
            class="btn btn-govco fill-btn-govco"
            style="width: fit-content"
            (click)="filtrarAlertas()"
            aria-label="Cargar más alertas">
            {{ 'visualizar_alertas.cargar_mas' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
